import { render, staticRenderFns } from "./VehiculosCargas.vue?vue&type=template&id=2b6d0fa6&lang=pug"
import script from "./VehiculosCargas.vue?vue&type=script&lang=js"
export * from "./VehiculosCargas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports